module.exports = __webpack_public_path__ + "img/pixing_yj_xiaodengbiao.76e77d97.jpg";